import { Injectable } from '@angular/core';

import { interpret, Interpreter } from 'xstate';
import { Store } from '@ngrx/store';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import * as fromRootStore from '@apps/root/store';
import { IAuroraState } from '@apps/aurora.state';

import { GlobalSearchEventType, GlobalSearchMachine, GlobalSearchContext } from './global-search-machine';

@Injectable({
    providedIn: 'root'
})
export class GlobalSearchService
{
    public contextor: Observable<GlobalSearchContext>;
    private searchMachine: Interpreter<any, any, any, any, any>;
    private searchValue: string = '';

    constructor (
        private store: Store<IAuroraState>
    )
    {
        this.searchMachine = interpret(GlobalSearchMachine).start();
        this.contextor = from(this.searchMachine)
            .pipe(
                map((state: any) =>
                    state.context
                )
            );
    }

    public launchSearch (searchValue: string)
    {
        if (searchValue?.trim())
        {
            searchValue = searchValue.trim();
            if (searchValue.length > 2)
            {
                this.searchValue = searchValue;
                this.searchMachine.send(GlobalSearchEventType.LAUNCH, { ctxt: { searchValue } });
                this.store.dispatch(fromRootStore.RootSearchStoreActions.RootSearchInitialized({ searchValue }));
                this.store.dispatch(fromRootStore.RootSearchStoreActions.RootSearchRequested());
            }
        }
        else
        {
            this.clearResults();
        }
    }

    public showResults ()
    {
        this.searchValue === '' ? this.searchMachine.send(GlobalSearchEventType.FOCUS) : this.searchMachine.send(GlobalSearchEventType.SHOW);
    }

    public hideResults ()
    {
        this.searchMachine.send(GlobalSearchEventType.HIDE);
    }

    public clearResults ()
    {
        this.searchValue = '';
        this.searchMachine.send(GlobalSearchEventType.CLEAR);
        this.store.dispatch(fromRootStore.RootSearchStoreActions.RootSearchResultsCleared());
    }

    public handleEnterKey ()
    {
        this.searchMachine.send(GlobalSearchEventType.HIDE);
        this.store.dispatch(fromRootStore.RootSearchStoreActions.RootSearchEnterKey({ searchValue: this.searchValue }));
    }
}
